import { Asset } from "./assets.model";
import { Organization } from "./organization.model";
export class Comment {
  id: number;
  body: string;
  media: Asset[];
  organization: Organization;
  title: string;
  create_date: string;
  constructor() {
    this.id = 0;
    this.body = "";
    this.organization = new Organization();
    this.media = [];
    this.title = "";
    this.create_date = "";
  }
}
